import React, { useMemo } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';
import { PrinterType } from '~/types/printer';
import message from '~/utils/message';
import { useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@restaurant/api';

const PrinterWifi = () => {
  const { settings, saveSettings } = usePrinter();
  const { data } = useSuspenseQuery({
    queryKey: ['getPrinterList'],
    queryFn: api.fetchPrinters,
    staleTime: Infinity,
  });

  const options = useMemo(
    () =>
      data.printers
        ?.filter(({ isActive }) => isActive)
        .map(({ printerId, name }) => ({
          value: printerId,
          label: <p className="text-lg mb-0">{name}</p>,
        })),
    [data.printers]
  );

  const onChange = (e: RadioChangeEvent) => {
    saveSettings({
      type: PrinterType.Wifi,
      printerId: e.target.value,
    });
    message.success('Berhasil menyimpan setting Wi-Fi Printer');
  };

  if (settings.type !== PrinterType.Wifi) return null;

  return (
    <div>
      <p className="text-lg">Pilih Printer Kasir:</p>
      {options?.length ? (
        <Radio.Group
          options={options}
          onChange={onChange}
          value={settings.printerId}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
          size="large"
        />
      ) : (
        <p>Belum ada printer</p>
      )}
    </div>
  );
};

export default PrinterWifi;
